var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBank = function SvgBank(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9379 2.56703C11.5649 2.08703 12.4364 2.08703 13.0634 2.56703L20.5064 8.25653C21.4544 8.98103 20.9459 10.493 19.7549 10.499H4.24489C3.05539 10.493 2.54539 8.98103 3.49489 8.25653L10.9379 2.56703ZM11.9999 7.87403C12.2983 7.87403 12.5844 7.7555 12.7954 7.54453C13.0064 7.33355 13.1249 7.0474 13.1249 6.74903C13.1249 6.45066 13.0064 6.16451 12.7954 5.95354C12.5844 5.74256 12.2983 5.62403 11.9999 5.62403C11.7015 5.62403 11.4154 5.74256 11.2044 5.95354C10.9934 6.16451 10.8749 6.45066 10.8749 6.74903C10.8749 7.0474 10.9934 7.33355 11.2044 7.54453C11.4154 7.7555 11.7015 7.87403 11.9999 7.87403Z",
    fill: "#0350BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12V16.5H7.5V12H5.25Z",
    fill: "#0350BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12V16.5H11.25V12H9Z",
    fill: "#0350BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12V16.5H15V12H12.75Z",
    fill: "#0350BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12V16.5H18.75V12H16.5Z",
    fill: "#0350BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.875C3 18.84 3.84 18 4.875 18H19.125C20.16 18 21 18.84 21 19.875V20.25C21 20.4489 20.921 20.6397 20.7803 20.7803C20.6397 20.921 20.4489 21 20.25 21H3.75C3.55109 21 3.36032 20.921 3.21967 20.7803C3.07902 20.6397 3 20.4489 3 20.25V19.875Z",
    fill: "#0350BB"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bank.bca89dbb.svg";
export { ForwardRef as ReactComponent };